import Track from './Track'
import { connect } from 'react-redux'


const mapStateToProps = (state) => ({
    title: state.track.title,
})


export default connect(mapStateToProps)(Track)